import type { ReactNode } from "react";

import { cn } from "./cn";

/** A money amount shown to a person ("₹12,500"). It is set in Newsreader, like page titles and customer names. Size and weight come from the text around it. */
export function Amount({
  children,
  className,
}: Readonly<{ children: ReactNode; className?: string }>) {
  return <span className={cn("font-serif font-medium", className)}>{children}</span>;
}
